var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#f1b31c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 9,
    fill: "#d22f27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 46,
    width: 62,
    height: 9,
    fill: "#d22f27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 33,
    width: 4,
    height: 4,
    fill: "#f1b31c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 37,
    r: 1.5,
    fill: "#6a462f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 27,
    x2: 27,
    y1: 33,
    y2: 42,
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    x2: 11,
    y1: 33,
    y2: 42,
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15,30a8.5678,8.5678,0,0,1,4-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23,30a8.5678,8.5678,0,0,0-4-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 23,
    y1: 33,
    y2: 33,
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 12,
    y1: 42,
    y2: 42,
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    x2: 28,
    y1: 42,
    y2: 42,
    fill: "none",
    stroke: "#6a462f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.12ca02a6acdc03a2d4d12c88cd95b57e.svg";
export { ForwardRef as ReactComponent };